import _ from "underscore";
import clearParameterValue from "./clear_parameter_value";

function areValuesEqual(valueA, valueB) {
  return _.isEqual(clearParameterValue(valueA), clearParameterValue(valueB));
}

export default areValuesEqual;
